module.exports = "/_next/static/images/alfamart_group-c652e28626662928c0dbd7f7623e8b7c.svg";